import { useContext, useRef } from 'react';
import ModalSvcContext from 'src/shared/services/modal/modal.context';
import ModalService from 'src/shared/services/modal/modal.service';
import APP_MODALS from 'src/static/enums/app.modals';
import Button from 'src/components/internal/button/button.component';

export default function SubmissionRejectionModalPage() {
	const modalRef = useRef<HTMLDivElement>(null);
	const modalContentRef = useRef<HTMLDivElement>(null); // Ref for modal content
	const modalSvc = useContext<ModalService>(ModalSvcContext);
	const reasonForRejection = modalSvc.getModals().value[0].data || {};

	// Function to close the modal
	const closeModal = () => {
		modalSvc.closeModal(APP_MODALS.SUBMISSION_REJECTION_MODAL);
	};

	return (
		<main
			className="fixed inset-0 bg-black cursor-pointer bg-opacity-50 pointer-events-auto flex items-center justify-center z-[10]"
			tabIndex={-1}
			ref={modalRef}
			onClick={closeModal}
		>
			{/* Modal content */}
			<div
				ref={modalContentRef}
				className="w-[343px] p-6 rounded-lg bg-white dark:text-white dark:bg-dark-800 min-h-[200px] md:w-[512px]"
			>
				{/* Modal header */}
				<div className="flex items-center justify-between ">
					{reasonForRejection === 'copyright-plagiarism' && (
						<h4 className="text-2xl font-bold leading-9">Copyright or Plagiarism</h4>
					)}
					{reasonForRejection === 'low-quality' && (
						<h4 className="text-2xl font-bold leading-9">
							Low Quality or Lacks Detail
						</h4>
					)}
					{reasonForRejection === 'spam-content' && (
						<h4 className="text-2xl font-bold leading-9">
							Spam or Promotional Content
						</h4>
					)}
					{reasonForRejection === 'duplicate' && (
						<h4 className="text-2xl font-bold leading-9">
							Duplicate or Already Covered
						</h4>
					)}
					{reasonForRejection === 'off-topic' && (
						<h4 className="text-2xl font-bold leading-9">Off-Topic or Misleading</h4>
					)}

					{/* the delete icon */}
					<i className="fa-solid fa-xmark cursor-pointer" onClick={closeModal}></i>
				</div>

				{/* Modal content text */}

				{reasonForRejection === 'copyright-plagiarism' && (
					<p className="mt-6 text-base leading-6">
						The content includes copyrighted material or is not original. Ensure you
						have the right to share all elements included.{' '}
					</p>
				)}
				{reasonForRejection === 'low-quality' && (
					<p className="mt-6 text-base leading-6">
						The submission is too vague, unclear, or missing key information. Consider
						adding more depth or improving readability.{' '}
					</p>
				)}
				{reasonForRejection === 'spam-content' && (
					<p className="mt-6 text-base leading-6">
						Submissions should provide value beyond self-promotion. If relevant, try
						adding insights or making it more educational.
					</p>
				)}
				{reasonForRejection === 'duplicate' && (
					<p className="mt-6 text-base leading-6">
						Similar content already exists. Try adding a new angle, unique insights, or
						a fresh perspective.{' '}
					</p>
				)}
				{reasonForRejection === 'off-topic' && (
					<p className="mt-6 text-base leading-6">
						The content does not fit the platform's theme or contains unverified
						information. Please ensure it aligns with Web3 and is factually accurate{' '}
					</p>
				)}

				{/* Button to close the modal */}
				<Button className="blue w-full mt-6 text-sm" onClick={closeModal}>
					Ok, got it!
				</Button>
			</div>
		</main>
	);
}
